// NOTICE: This file was copied from the oppizi-shared repository, do
// not modify it here.

/**
 * Processes an array of inventory movements
 * @param {Array<MovementInput>} movements
 * @returns {Array<Movement>}
 */
export const processInventoryMovements = `
  mutation processInventoryMovements($movements: [ProcessInventoryMovementInput]!) {
    processInventoryMovements(input: $movements) {
      id,
      quantity,
      movementType { id },
      author { id },
      relatedUser { id },
      relatedCity { id },
      relatedMission { id },
      comments,
      dateTime,
      relatedCampaign { id }
    }
  }
`

/**
 * Get or search for inventory items.
 * @param {number} first Get the first x records, limit is 500
 * @param {string} after The cursort to start getting the records from
 * @param {number} cityId To filter inventory by this city
 * @param {number} clientId To filter inventory by this client
 * @param {number} typeId To filter inventory by this type
 * @param {string} searchText To search by inventory description
 * @param {number} ambassadorId To filter by ambassador
 * @param {Boolean} current Can only specify if ambassadorId is also specified.
 * If set to true then it will only return the inventory that the ambassador
 * currently has. If false it returns inventory the ambassador has had in the
 * past.
 * @returns {Array<InventoryItem>}
 */
export const getInventory = `
  query getInventory(
    $first: Int,
    $after: String,
    $cityId: ID,
    $clientId: ID,
    $typeId: ID,
    $searchText: String
    $ambassadorId: ID
    $current: Boolean
  ) {
    inventoryItems(
      first: $first,
      after: $after,
      cityId: $cityId,
      clientId: $clientId,
      typeId: $typeId,
      searchText: $searchText
      ambassadorId: $ambassadorId
      current: $current
    ){
      pageInfo {
        endCursor,
        hasNextPage
      },
      totalCount,
      edges {
        node {
          id,
          client { id },
          inventoryType { id },
          description,
          campaignId,
          campaignArtworkId,
          tag,
          movementsV2 {
            nodes {
              id,
              quantity,
              movementType { id },
              relatedUser {
                id,
                firstName,
                lastName,
              },
              relatedCity { id },
              relatedMission { id },
              comments,
              dateTime,
              relatedCampaign {
                id,
                name,
              },
            }
          }
        }
      }
    }
  }
`

/**
 * Get an inventory item
 * @param {number} id
 * @returns {InventoryItem}
 */
export const getInventoryItem = `
  query getInventoryItem(
    $id: ID!,
  ) {
    inventoryItem(
      id: $id,
    ){
      id,
      client { id },
      inventoryType { id },
      description,
      campaignId,
      campaignArtworkId,
      tag,
      movements {
        nodes {
          id,
          quantity,
          movementType { id },
          relatedUser {
            id,
            firstName,
            lastName,
          },
          relatedCity { id },
          relatedMission { id },
          comments,
          dateTime,
          relatedCampaign {
            id,
            name,
          },
        }
      }
    }
  }
`
